import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { FullScreenImageSection, ImageWrapper } from './index.styled'
import Logo from 'components/ui/logo'
import ScrollDownArrow from 'components/ui/scroll-arrow'

import { onArrowClick } from '../../helpers/onArrow'

const FullScreenImage = ({ data }) => {
  const { className, heroSection, heroSectionClassName, images } = data
  return (
    <>
      <FullScreenImageSection
        className={[className && className, ' fullscreen-image-section']}
      >
        <ImageWrapper>
          <GatsbyImage image={getImage(images[0]?.file)} alt="" />
        </ImageWrapper>

        {heroSection && (
          <>
            <Logo className={heroSectionClassName} />

            <ScrollDownArrow
              className={heroSectionClassName}
              onClick={onArrowClick}
            />
          </>
        )}
      </FullScreenImageSection>
    </>
  )
}

export default FullScreenImage
